module.exports = __webpack_public_path__ + "img/历程.ac58a60b.jpg";